// @ts-nocheck
// Store Custom Component
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { linkStyles } from "@store/Themes/common/mixins/link";
import { autocompleteProps } from "@store/Themes/common/props/autocomplete";
import { focusUpdateStyles } from "@toolkit/Themes/common/mixins";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    title: string;
    linkText?: string;
    linkHandler?: () => void;
    className?: string;
}

type Props = OwnProps;

export interface AutocompleteHeaderStyles {
    wrapper?: InjectableCss;
    text?: TypographyPresentationProps;
    link?: LinkPresentationProps;
}

export const autocompleteHeaderStyles: AutocompleteHeaderStyles = {
    wrapper: autocompleteProps.headerWrapper,
    text: autocompleteProps.headerText,
    link: {
        css: css`
            ${linkStyles("text.link", "text.linkAltHover", false, true)};
            ${focusUpdateStyles(true)}

            ${({ theme }) => `
                font-weight: ${theme.design.typography.weight.semibold};
                font-size: ${theme.design.typography.size.smallest};
                margin-top: ${theme.design.typography.spacing.smaller};
            `},
        `,
    },
};

const styles = autocompleteHeaderStyles;

const AutocompleteHeader = ({ title, linkText, linkHandler, className }: Props) => {
    return (
        <StyledWrapper {...styles.wrapper} className={className}>
            <Typography {...styles.text}>{title}</Typography>
            {linkText && (
                <Link {...styles.link} onClick={linkHandler}>
                    {translate("Clear Search History")}
                </Link>
            )}
        </StyledWrapper>
    );
};

export default AutocompleteHeader;
